import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import AiCoachCard from '../../../components/ai/AiCoachCard'
import {
  fetchWorkoutContext,
  buildWorkoutCoachPrompt,
} from '../../../lib/ai/workoutCoachPrompt'

// Thin wrapper around AiCoachCard. The shell handles the UI loop;
// this file only owns the workout-specific data fetch + prompt
// composition.
export default function WorkoutCoach() {
  const { i18n } = useTranslation()
  const buildPrompt = useCallback(async ({ user }) => {
    const context = await fetchWorkoutContext(user.id)
    return { prompt: buildWorkoutCoachPrompt(context, i18n.language === 'ar' ? 'ar' : 'en') }
  }, [i18n.language])

  return <AiCoachCard kind="workout_coach" i18nKey="workoutCoach" buildPrompt={buildPrompt} />
}
